import React from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBoxOpen, faBox, faGift } from '@fortawesome/pro-light-svg-icons';
import { packagingTabs } from '../../config/packagingTabsConfig';
import { PackagingTabKey } from '../../models/Packaging';

interface PackagingTabsProps {
  activeTab: PackagingTabKey;
  onTabChange: (tab: PackagingTabKey) => void;
  counts?: Record<PackagingTabKey, number>;
  isLoadingCounts?: boolean;
}

const PackagingTabs: React.FC<PackagingTabsProps> = ({ activeTab, onTabChange, counts, isLoadingCounts = false }) => {
  const { t } = useTranslation('packagingModule');

  // Formato compacto para números grandes
  const formatCount = (count?: number) => {
    if (count === undefined || count === null) return null;
    if (count >= 1000) return `${(count / 1000).toFixed(1)}k`;
    return String(count);
  };

  const getTabIcon = (tabKey: PackagingTabKey) => {
    if (tabKey === 'boxes') return faBox;
    if (tabKey === 'marketing') return faGift;
    return faBoxOpen;
  };

  return (
    <div
      className="flex bg-card-bg rounded-lg text-sm p-1 mb-4 overflow-x-auto scrollbar-hide light:border-card-border light:border"
      style={{ WebkitOverflowScrolling: 'touch' }}
    >
      {packagingTabs.map((tab) => {
        const count = counts?.[tab.key];
        const countText = formatCount(count);

        return (
          <a
            key={tab.key}
            href="#"
            onClick={(e) => {
              e.preventDefault();
              onTabChange(tab.key);
            }}
            className={`px-3 py-1 rounded hover:bg-hover-press whitespace-nowrap flex items-center gap-1.5 ${
              activeTab === tab.key ? 'bg-hover-press' : ''
            }`}
            data-testid={`packaging-tab-${tab.key}`}
          >
            <FontAwesomeIcon icon={getTabIcon(tab.key)} className="w-3.5 h-3.5" />
            <span>{t(tab.labelKey)}</span>
            {countText && (
              <span
                className={`text-xs px-1.5 py-0.5 rounded-full min-w-[20px] text-center ${
                  activeTab === tab.key ? 'bg-primary/20 text-primary' : 'bg-muted text-muted-foreground'
                } ${isLoadingCounts ? 'animate-pulse' : ''}`}
              >
                {countText}
              </span>
            )}
          </a>
        );
      })}
    </div>
  );
};

export default PackagingTabs;
